import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { isAdmin } from '../../utils';
import EditIcon from '@material-ui/icons/Edit';
import Add from '@material-ui/icons/Add';
import Star from '@material-ui/icons/Star';
import IconButton from '@material-ui/core/IconButton';
import swal from 'sweetalert';
import { withPrefix } from 'gatsby';
import styled from 'styled-components';
import TrackVisibility from 'react-on-screen';

const styles = theme => ({
  card: {
    display: 'flex',
    margin: 10,
    width: 350,
    height: 200,
    cursor: 'pointer'
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    width: '220px',
    overflow: 'hidden'
  },
  content: {
    flex: '1 0 auto'
  },
  cover: {
    width: 200,
    height: 200
  }
});

export const SwitchOnHover = styled(CardMedia)`
  position: relative;
  &:hover:after,
  &:active:after,
  &:focus:after {
    opacity: 1;
  }
  &:after {
    transition: opacity 0.5s;
    opacity: ${p => (p.isVisible ? 1 : 0)};
    content: '';
    background: url(${p => p.hoverAvatarNumber});
    position: absolute;
    top: 0;
    /* background-size: cover; */
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  &:before{
    content: '${p => !!p.name && p.name}';
    position:absolute;
    color: white;
    bottom:5px;
    left: 5px;
    font-size:16px;
    z-index:999;
  }
`;

class MediaControlCard extends Component {
  render() {
    const {
      classes,
      photoURL = '',
      username,
      money,
      rating = 0,
      currentUser,
      id,
      setUserMoney,
      addUserMoney,
      addUserRating,
      lastMonthRatingSummery,
      avatarNumber,
      hoverAvatarNumber,
      reviewText
    } = this.props;
    const admin = isAdmin({ id: currentUser });
    const adminOrCurrentUser = admin || currentUser === id;
    const url = photoURL.includes('firebasestorage') ? photoURL : photoURL + '?width=400';
    const fullSizeStyles = reviewText ? { width: '100%', height: '400px' } : {};

    const prompt = e => {
      e.stopPropagation();
      swal({
        text: `Задати баланс для ${username}`,
        content: 'input',
        button: {
          text: 'ок'
        }
      }).then(money => {
        setUserMoney(id, money);
      });
    };

    const promptAdd = e => {
      e.stopPropagation();

      swal({
        text: `Додати гроші для ${username}`,
        content: 'input',
        button: {
          text: 'ок'
        }
      }).then(money => {
        addUserMoney(id, money);
      });
    };

    const promptAddRating = e => {
      e.stopPropagation();

      swal({
        text: `Додати рейтинг для ${username}`,
        content: 'input',
        button: {
          text: 'ок'
        }
      }).then(rating => {
        addUserRating(id, rating);
      });
    };

    const ratingText = lastMonthRatingSummery
      ? `Рейтинг за місяць: ${lastMonthRatingSummery} `
      : '';

    return (
      <Card
        className={classes.card}
        onClick={() => {
          window.location = `/rating?user=${id}`;
        }}
        style={fullSizeStyles}
      >
        {avatarNumber ? (
          detectMob() ? (
            <TrackVisibility throttleInterval={200}>
              <SwitchOnHover
                className={classes.cover}
                image={withPrefix(`sigma/thumb/${avatarNumber}.jpg`)}
                hoverAvatarNumber={withPrefix(`sigma/thumb/${hoverAvatarNumber}.jpg`)}
              />
            </TrackVisibility>
          ) : (
            <SwitchOnHover
              className={classes.cover}
              image={withPrefix(`sigma/thumb/${avatarNumber}.jpg`)}
              hoverAvatarNumber={withPrefix(`sigma/thumb/${hoverAvatarNumber}.jpg`)}
            />
          )
        ) : (
          <CardMedia
            className={classes.cover}
            image={url}
            style={reviewText ? { height: '100%' } : {}}
          />
        )}
        <div
          className={classes.details}
          style={{ backgroundColor: reviewText ? '#202527' : 'white', ...fullSizeStyles }}
        >
          <CardContent className={classes.content}>
            <Typography
              component="h5"
              variant="h5"
              style={{ color: reviewText ? 'white' : 'black' }}
            >
              {username}
            </Typography>
            <Typography
              variant="subtitle1"
              color="textSecondary"
              style={
                !reviewText
                  ? {
                      color: 'rgb(199, 18, 8)',
                      fontSize: '12px'
                    }
                  : {
                      color: 'white',
                      marginTop: 5,
                      textTransform: 'none',
                      lineHeight: 1.2,
                      fontSize: '13px'
                    }
              }
            >
              {reviewText ? reviewText : ratingText}
              <br />
            </Typography>
            {!reviewText && (
              <p style={{ fontSize: 12, color: 'rgb(199, 18, 8)' }}>Рейтинг: {rating}</p>
            )}
            <Typography variant="subtitle2" color="textSecondary">
              {adminOrCurrentUser && <span>Баланс: {money}</span>}
              {admin && (
                <div>
                  <IconButton aria-label="edit" onClick={prompt}>
                    <EditIcon style={{ fontSize: 18 }} />
                  </IconButton>
                  <IconButton aria-label="Add" onClick={promptAdd}>
                    <Add style={{ fontSize: 18 }} />
                  </IconButton>
                  <IconButton aria-label="Add" onClick={promptAddRating}>
                    <Star style={{ fontSize: 18 }} />
                  </IconButton>
                </div>
              )}
            </Typography>
          </CardContent>
        </div>
      </Card>
    );
  }
}

MediaControlCard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

function detectMob() {
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true;
  } else {
    return false;
  }
}

export default withStyles(styles, { withTheme: true })(MediaControlCard);
